(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6465],{

/***/ 26465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ TravelPage_TravelPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/pages/TravelPage/TravelPage.module.scss
var TravelPage_module = __webpack_require__(86627);
var TravelPage_module_default = /*#__PURE__*/__webpack_require__.n(TravelPage_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./src/components/models/travel/HeaderBlock/index.tsx + 6 modules
var HeaderBlock = __webpack_require__(1991);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/components/models/travel/navs/PageNavigation/PageNavigation.module.scss
var PageNavigation_module = __webpack_require__(46232);
var PageNavigation_module_default = /*#__PURE__*/__webpack_require__.n(PageNavigation_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Navbar.js + 11 modules
var Navbar = __webpack_require__(38643);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 1 modules
var Nav = __webpack_require__(23144);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./src/components/elements/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(4514);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/components/models/travel/SocialSharingModal/SocialSharingModal.module.scss
var SocialSharingModal_module = __webpack_require__(58149);
var SocialSharingModal_module_default = /*#__PURE__*/__webpack_require__.n(SocialSharingModal_module);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 6 modules
var Modal = __webpack_require__(6212);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Email.js
var Email = __webpack_require__(50891);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Twitter.js
var Twitter = __webpack_require__(25084);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/WhatsApp.js
var WhatsApp = __webpack_require__(84007);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Link.js
var Link = __webpack_require__(43800);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./src/lib/ga/gtag.ts
var gtag = __webpack_require__(64426);
;// CONCATENATED MODULE: ./src/components/models/travel/SocialSharingModal/SocialSharingModal.tsx














var SocialSharingModal = function(param) {
    var travel = param.travel, triggerElement = param.triggerElement;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(false), show = ref[0], setShow = ref[1];
    var ref1 = (0,react.useState)(false), linkCopied = ref1[0], setLinkCopied = ref1[1];
    var handleClose = function() {
        return setShow(false);
    };
    var handleShow = function() {
        setLinkCopied(false);
        setShow(true);
        (0,gtag/* sendEventTravelSharingOpened */._Y)({
            itemId: "".concat(travel.id)
        });
    };
    var url = "https://www.kultour.ch" + "/tour/" + travel.seoSettings.urlSlug;
    var buildUrl = function(platform) {
        var encode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var ref, ref1;
        var utmCampaign = ((ref1 = (ref = travel.pricing) === null || ref === void 0 ? void 0 : ref.travels[0]) === null || ref1 === void 0 ? void 0 : ref1.catalogCode) ? "".concat(travel.pricing.travels[0].catalogCode, "_").concat(travel.pricing.travels[0].travelCode) : "no_travel_import";
        var utmUrl = "".concat(url, "?utm_source=").concat(platform, "&utm_medium=social&utm_campaign=").concat(utmCampaign, "&utm_content=website_share_button");
        if (!encode) {
            return utmUrl;
        }
        return encodeURIComponent(utmUrl);
    };
    // const urlEncoded = encodeURIComponent(url)
    var sendEvent = function(name) {
        (0,gtag/* sendEventTravelSharingExecuted */.Ti)({
            method: name,
            itemId: "".concat(travel.id)
        });
    };
    var platforms = [
        {
            name: "email",
            label: t("socialSharing.sendEmail"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Email/* default */.Z, {
                className: (SocialSharingModal_module_default()).icon
            }),
            url: "mailto:?subject=".concat(travel.name, " | ").concat("kultour.ch", "&body=").concat(buildUrl("email", true))
        },
        {
            name: "copy_link",
            label: t("socialSharing.copyLink"),
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: !linkCopied ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    className: (SocialSharingModal_module_default()).icon
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                    className: (SocialSharingModal_module_default()).icon
                })
            }),
            onClick: function(event) {
                event.preventDefault();
                // event.stopPropagation()
                navigator.clipboard.writeText(buildUrl("sharing_link", false));
                setLinkCopied(true);
            },
            url: "#"
        },
        {
            name: "whatsapp",
            label: "WhatsApp",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsApp/* default */.Z, {
                className: (SocialSharingModal_module_default()).icon
            }),
            url: lib/* isMobile */.tq ? "whatsapp://send?text=" + buildUrl("whatsapp", true) : "https://web.whatsapp.com/send?text=" + buildUrl("whatsapp", true)
        },
        {
            name: "facebook",
            label: "Facebook",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                name: "facebook",
                className: (SocialSharingModal_module_default()).icon
            }),
            url: "https://www.facebook.com/sharer/sharer.php?u=" + buildUrl("facebook", true)
        },
        {
            name: "twitter",
            label: "Twitter",
            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                className: (SocialSharingModal_module_default()).icon
            }),
            url: "https://twitter.com/intent/tweet?url=" + buildUrl("twitter", true)
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ react.cloneElement(triggerElement, {
                onClick: handleShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
                size: "lg",
                show: show,
                onHide: handleClose,
                className: (SocialSharingModal_module_default()).modal,
                centered: true,
                scrollable: false,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (SocialSharingModal_module_default()).close,
                        "aria-label": "Close",
                        onClick: handleClose,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-hidden": "true",
                            children: "\xd7"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default.Body */.Z.Body, {
                        className: (SocialSharingModal_module_default()).body,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (SocialSharingModal_module_default()).heading,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default.Title */.Z.Title, {
                                        className: (SocialSharingModal_module_default()).title,
                                        children: t("socialSharing.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: t("socialSharing.shareNow")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "justify-content-center mt-3 mb-4",
                                children: platforms.map(function(platform, index) {
                                    var onClick = function(event) {
                                        sendEvent(platform.name);
                                    };
                                    if (platform.onClick) {
                                        onClick = function(event) {
                                            sendEvent(platform.name);
                                            // @ts-ignore
                                            platform.onClick(event);
                                        };
                                    }
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                        xs: "auto",
                                        as: "a",
                                        className: (SocialSharingModal_module_default()).sharingLink,
                                        href: platform.url,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: onClick,
                                        "data-tr-click": "travel_page:sharing:execute",
                                        "data-tr-sharing_method": platform.name,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (SocialSharingModal_module_default()).iconWrap,
                                                children: platform.icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: (SocialSharingModal_module_default()).label,
                                                children: platform.label
                                            })
                                        ]
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SocialSharingModal_SocialSharingModal = (SocialSharingModal);

;// CONCATENATED MODULE: ./src/components/models/travel/SocialSharingModal/index.tsx


;// CONCATENATED MODULE: ./src/components/models/travel/navs/PageNavigation/functions/navItemsHook.ts
var navItemsHook = function(items) {
    return items;
};
/* harmony default export */ var functions_navItemsHook = (navItemsHook);

;// CONCATENATED MODULE: ./src/components/models/travel/navs/PageNavigation/functions/pageNavItems.ts

var pageNavItems = function(travel, t) {
    var items = [];
    // guides
    if (travel.travelGuides.length) {
        items.push({
            name: "guides",
            label: t("travel.travelGuides"),
            href: "#guides"
        });
    }
    // teams
    if (travel.teams.length) {
        items.push({
            name: "teams",
            label: t(!travel.travelGuides.length ? "travel.travelGuides" : "travel.teams"),
            href: "#teams"
        });
    }
    // itinerary & extensions
    if (hasProgram(travel)) {
        items.push({
            name: "itinerary",
            label: t("travel.itinerary.program"),
            href: "#itinerary"
        });
    }
    // accommodations
    if (travel.accommodationAssignments.length) {
        items.push({
            name: "accommodation",
            label: t(travel.accommodationAssignments.length == 1 ? "travel.accommodation" : "travel.accommodations"),
            href: "#accommodation"
        });
    }
    // pricing
    items.push({
        name: "pricing",
        label: t("travel.pricesAndServices"),
        href: "#pricing"
    });
    // gallery
    if (travel.gallery.images.length) {
        items.push({
            name: "gallery",
            label: t("travel.gallery"),
            href: "#gallery"
        });
    }
    // destinations
    if (travel.destinations.length) {
        items.push({
            name: "destinations",
            label: t("travel.countryInformation"),
            href: "#destinations"
        });
    }
    return functions_navItemsHook(items);
};
var hasProgram = function(travel) {
    switch(travel.programType){
        case "TEXT":
            if (travel.programText) {
                return true;
            }
            break;
        case "ITINERARY":
            if (travel.itinerary.items.length > 0) {
                return true;
            }
            break;
    }
    return false;
};
/* harmony default export */ var functions_pageNavItems = (pageNavItems);

;// CONCATENATED MODULE: ./src/hooks/useDownloadFile.ts



var useDownloadFile = function(param) {
    var apiDefinition = param.apiDefinition, _preDownloading = param.preDownloading, preDownloading = _preDownloading === void 0 ? function() {} : _preDownloading, _postDownloading = param.postDownloading, postDownloading = _postDownloading === void 0 ? function() {} : _postDownloading, _urlCreator = param.urlCreator, urlCreator = _urlCreator === void 0 ? function(data) {
        return URL.createObjectURL(new Blob([
            data
        ]));
    } : _urlCreator, onError = param.onError, getFileName = param.getFileName;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(), url = ref1[0], setFileUrl = ref1[1];
    var ref2 = (0,react.useState)(), name = ref2[0], setFileName = ref2[1];
    (0,react.useEffect)(function() {
        if (url) {
            var ref1;
            (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.click();
            URL.revokeObjectURL(url);
        }
    }, [
        url
    ]) // Dies wird ausgeführt, wenn sich die `url` ändert
    ;
    var download = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var data, url, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        preDownloading();
                        return [
                            4,
                            apiDefinition()
                        ];
                    case 1:
                        data = _state.sent().data;
                        url = urlCreator(data);
                        setFileUrl(url);
                        setFileName(getFileName());
                        // ref.current?.click()
                        postDownloading();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        onError();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function download() {
            return _ref.apply(this, arguments);
        };
    }();
    return {
        download: download,
        ref: ref,
        url: url,
        name: name
    };
};

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 42 modules
var axios = __webpack_require__(5121);
// EXTERNAL MODULE: ./src/integrations/tracking/custom-sea-tracking/SeaTracker.ts + 1 modules
var SeaTracker = __webpack_require__(19838);
;// CONCATENATED MODULE: ./src/components/models/travel/navs/PageNavigation/PageNavigation.tsx

















var PageNavigation = function(param) {
    var travel = param.travel;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var iconSize = 1.8;
    var items = functions_pageNavItems(travel, t);
    var ref = (0,react.useState)(true), isNavCollapsed = ref[0], setIsNavCollapsed = ref[1];
    var handleNavCollapse = function() {
        setIsNavCollapsed(!isNavCollapsed);
    };
    // PDF Generator
    var ref1 = (0,react.useState)(false), pdfIsLoading = ref1[0], setPdfIsLoading = ref1[1];
    var generatePdf = function(travel) {
        return axios/* default.get */.Z.get("".concat("https://api.surprise-kultour.ch", "/rest/travel/pdf/download?slug=").concat(travel.seoSettings.urlSlug, "&tenantId=").concat("1"), {
            responseType: "blob"
        });
    };
    var onErrorGeneratePdf = function() {
        setPdfIsLoading(false);
        alert("Fehler beim Download");
    };
    var getFileName = function(travel) {
        return "".concat(travel.seoSettings.urlSlug, ".pdf");
    };
    var ref2 = useDownloadFile({
        preDownloading: function() {
            return setPdfIsLoading(true);
        },
        apiDefinition: function() {
            return generatePdf(travel);
        },
        postDownloading: function() {
            return setPdfIsLoading(false);
        },
        onError: onErrorGeneratePdf,
        getFileName: function() {
            return getFileName(travel);
        },
        urlCreator: function(data) {
            return URL.createObjectURL(new Blob([
                data
            ], {
                type: "application/pdf"
            }));
        }
    }), ref3 = ref2.ref, url = ref2.url, download = ref2.download, name = ref2.name;
    var handleGeneratePdf = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            download()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleGeneratePdf() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: (PageNavigation_module_default()).root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                        expand: "xxl",
                        className: (PageNavigation_module_default()).navbar,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                "aria-controls": "travel-page-nav",
                                type: "button",
                                "aria-label": "Toggle navigation",
                                className: "navbar-toggler collapsed",
                                "aria-expanded": !isNavCollapsed,
                                onClick: handleNavCollapse,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "navbar-toggler-icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "".concat(isNavCollapsed ? "collapse" : "", " navbar-collapse"),
                                id: "travel-page-nav",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                    className: (PageNavigation_module_default()).nav,
                                    children: items.map(function(item, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default.Link */.Z.Link, {
                                            href: item.href,
                                            className: (PageNavigation_module_default()).navLink,
                                            onClick: handleNavCollapse,
                                            "data-tr-click": "travel_page:navigation:click",
                                            "data-tr-page_link_name": item.name,
                                            children: item.label
                                        }, index);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (PageNavigation_module_default()).iconLinks,
                        children: [
                            travel.travelPdf.url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                href: travel.travelPdf.url,
                                className: (PageNavigation_module_default()).iconLink,
                                "aria-label": "Download PDF",
                                target: "_blank",
                                rel: "noreferrer",
                                "data-tr-click": "travel_page:travel_pdf:download",
                                onClick: function() {
                                    // Track PDF download via SEA Tracker
                                    SeaTracker/* default.trackDownloadPdf */.Z.trackDownloadPdf(travel.seoSettings.urlSlug);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PageNavigation_module_default()).icon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                            name: "download",
                                            size: iconSize
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (PageNavigation_module_default()).label,
                                        children: t("travel.interactions.downloadPdf")
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: url,
                                        download: name,
                                        className: "hidden",
                                        ref: ref3
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        onClick: function() {
                                            handleGeneratePdf();
                                            // Track PDF download via SEA Tracker
                                            SeaTracker/* default.trackDownloadPdf */.Z.trackDownloadPdf(travel.seoSettings.urlSlug);
                                        },
                                        className: (PageNavigation_module_default()).iconLink,
                                        "aria-label": "Download PDF",
                                        "data-tr-click": "travel_page:travel_pdf:download",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PageNavigation_module_default()).icon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                    name: "download",
                                                    size: iconSize
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PageNavigation_module_default()).label,
                                                children: t("travel.interactions.downloadPdf")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (PageNavigation_module_default()).spinnerWrap,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "spinner-border spinner-border-sm text-secondary ".concat((PageNavigation_module_default()).loadingSpinner, " ").concat(pdfIsLoading ? (PageNavigation_module_default()).isLoading : ""),
                                                    role: "status"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialSharingModal_SocialSharingModal, {
                                travel: travel,
                                triggerElement: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (PageNavigation_module_default()).iconLink,
                                    "data-tr-click": "travel_page:sharing:open",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (PageNavigation_module_default()).icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                                name: "share",
                                                size: iconSize
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (PageNavigation_module_default()).label,
                                            children: t("travel.interactions.share")
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var PageNavigation_PageNavigation = (PageNavigation);

;// CONCATENATED MODULE: ./src/components/models/travel/navs/PageNavigation/index.tsx


// EXTERNAL MODULE: ./src/components/models/travel/IntroBlock/index.tsx + 6 modules
var IntroBlock = __webpack_require__(1790);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TravelGuideBlock/index.tsx + 3 modules
var TravelGuideBlock = __webpack_require__(30170);
// EXTERNAL MODULE: ./src/components/models/itinerary/ItineraryBlock/index.tsx + 4 modules
var ItineraryBlock = __webpack_require__(97874);
// EXTERNAL MODULE: ./src/components/models/travel/PricingBlock/index.tsx + 5 modules
var PricingBlock = __webpack_require__(82797);
// EXTERNAL MODULE: ./src/components/models/accommodation/AccommodationBlock/index.tsx + 11 modules
var AccommodationBlock = __webpack_require__(51382);
// EXTERNAL MODULE: ./src/components/models/travelGuide/TeamsBlock/index.tsx + 1 modules
var TeamsBlock = __webpack_require__(49542);
// EXTERNAL MODULE: ./src/components/models/travel/GalleryBlock/index.tsx + 1 modules
var GalleryBlock = __webpack_require__(25436);
// EXTERNAL MODULE: ./src/components/models/travel/DestinationsBlock/index.tsx + 7 modules
var DestinationsBlock = __webpack_require__(54592);
// EXTERNAL MODULE: ./src/components/models/newsletter/NewsletterForm/index.tsx + 1 modules
var NewsletterForm = __webpack_require__(89570);
;// CONCATENATED MODULE: ./src/components/models/newsletter/NewsletterBanner/NewsletterBanner.tsx



var NewsletterBanner = function(param) {
    var classNames = param.classNames;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        fluid: true,
        className: "bg-tertiary an-wobble-horizontal-trigger ".concat(classNames),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                className: "justify-content-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                    lg: 9,
                    xl: 7,
                    className: "my-5",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterForm/* default */.Z, {})
                })
            })
        })
    });
};
/* harmony default export */ var NewsletterBanner_NewsletterBanner = (NewsletterBanner);

;// CONCATENATED MODULE: ./src/components/models/newsletter/NewsletterBanner/index.tsx


// EXTERNAL MODULE: ./src/components/models/cms/blocks/BestsellerSliderBlock/index.ts + 3 modules
var BestsellerSliderBlock = __webpack_require__(2273);
// EXTERNAL MODULE: ./src/components/models/cms/blocks/ContactBannerBlock/index.ts + 1 modules
var ContactBannerBlock = __webpack_require__(67860);
// EXTERNAL MODULE: ./src/components/models/booking/BookingSidebar/BookingSidebar.module.scss
var BookingSidebar_module = __webpack_require__(30839);
var BookingSidebar_module_default = /*#__PURE__*/__webpack_require__.n(BookingSidebar_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./src/components/elements/icons/ArrowIcon/index.ts + 1 modules
var ArrowIcon = __webpack_require__(66707);
// EXTERNAL MODULE: ./src/components/models/travel/highlights/TravelHighlightsList/TravelHighlightsList.module.scss
var TravelHighlightsList_module = __webpack_require__(1701);
var TravelHighlightsList_module_default = /*#__PURE__*/__webpack_require__.n(TravelHighlightsList_module);
;// CONCATENATED MODULE: ./src/components/models/travel/highlights/TravelHighlightsList/TravelHighlightsList.tsx



var TravelHighlightsList = function(param) {
    var highlights = param.highlights;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: highlights.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TravelHighlightsList_module_default()).title,
                    children: t("travel.travelHighlights")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (TravelHighlightsList_module_default()).list,
                    children: highlights.map(function(highlight, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: highlight.text
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var TravelHighlightsList_TravelHighlightsList = (TravelHighlightsList);

;// CONCATENATED MODULE: ./src/components/models/travel/highlights/TravelHighlightsList/index.tsx


// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
;// CONCATENATED MODULE: ./src/components/models/booking/BookingSidebar/BookingSidebarBottomContent/BookingSidebarBottomContent.tsx

var BookingSidebarBottomContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var BookingSidebarBottomContent_BookingSidebarBottomContent = (BookingSidebarBottomContent);

;// CONCATENATED MODULE: ./src/components/models/booking/BookingSidebar/BookingSidebarBottomContent/index.tsx


;// CONCATENATED MODULE: ./src/components/models/booking/BookingSidebar/BookingSidebar.tsx













var InitBooking = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(8999), __webpack_require__.e(4275), __webpack_require__.e(8356), __webpack_require__.e(1141), __webpack_require__.e(5879)]).then(__webpack_require__.bind(__webpack_require__, 21141));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21141)
            ];
        }
    },
    ssr: false
});
var BookingSidebar = function(param) {
    var travel = param.travel, cmsConfig = param.cmsConfig;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref = (0,react.useState)(false), mobileBookingOpen = ref[0], setMobileBookingOpen = ref[1];
    var handleOpen = function() {
        setMobileBookingOpen(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                as: "aside",
                xs: "auto",
                className: "d-xxl-block ".concat((BookingSidebar_module_default()).root, " ").concat(mobileBookingOpen ? "d-block" : "d-none"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BookingSidebar_module_default()).sidebarContent,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InitBooking, {
                            contactBlockSettings: cmsConfig.contactBlockSettings,
                            setMobileOpen: setMobileBookingOpen,
                            colorTheme: "dark",
                            navType: "lead"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSidebarBottomContent_BookingSidebarBottomContent, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                className: "m-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelHighlightsList_TravelHighlightsList, {
                                            highlights: travel.highlights
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                className: "".concat((BookingSidebar_module_default()).mobileBar, " d-block d-xxl-none"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                    className: "justify-content-between align-items-center my-2 ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                            xs: "auto",
                            className: (BookingSidebar_module_default()).info,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: t("booking.pricePerPerson")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (BookingSidebar_module_default()).price,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: (BookingSidebar_module_default()).from,
                                            children: [
                                                t("booking.priceFrom"),
                                                "\xa0"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: (BookingSidebar_module_default()).price,
                                            children: (0,helpers/* formatPrice */.T4)(travel.minPrice, travel.currency)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            xs: "auto",
                            className: "ps-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                variant: "signal",
                                className: "an-wobble-horizontal-trigger fs-5 text-uppercase",
                                onClick: handleOpen,
                                "data-tr-click": "booking_funnel:booking_start:click",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowIcon/* default */.Z, {
                                        fontsize: "5rem",
                                        className: "me-2"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "d-none d-sm-inline-block",
                                        children: t("booking.bookNow")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "d-sm-none",
                                        children: t("booking.book")
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var BookingSidebar_BookingSidebar = (BookingSidebar);

;// CONCATENATED MODULE: ./src/components/models/booking/BookingSidebar/index.tsx


// EXTERNAL MODULE: ./src/components/models/travel/TestimonialsBlock/index.tsx + 1 modules
var TestimonialsBlock = __webpack_require__(12575);
;// CONCATENATED MODULE: ./src/components/pages/TravelPage/TravelPage.tsx


















var TravelPage = function(param) {
    var travel = param.travel, cmsConfig = param.cmsConfig;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderBlock/* default */.Z, {
                travel: travel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        fluid: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TravelPage_module_default()).content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PageNavigation_PageNavigation, {
                                            travel: travel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IntroBlock/* default */.Z, {
                                            travel: travel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelGuideBlock/* default */.Z, {
                                            travelGuides: travel.travelGuides
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TeamsBlock/* default */.Z, {
                                            teams: travel.teams
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItineraryBlock/* default */.Z, {
                                            travel: travel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AccommodationBlock/* default */.Z, {
                                            accommodationAssignments: travel.accommodationAssignments
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingBlock/* default */.Z, {
                                            travel: travel
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GalleryBlock/* default */.Z, {
                                            gallery: travel.gallery
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialsBlock/* default */.Z, {
                                            testimonials: travel.testimonials
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DestinationsBlock/* default */.Z, {
                                            destinations: travel.destinations
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingSidebar_BookingSidebar, {
                                    travel: travel,
                                    cmsConfig: cmsConfig
                                })
                            ]
                        })
                    }),
                    travel.travelConsultant && /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactBannerBlock/* default */.Z, {
                        block: {
                            employee: travel.travelConsultant,
                            phone: ((ref = travel.travelConsultant) === null || ref === void 0 ? void 0 : ref.phone) ? travel.travelConsultant.phone : "",
                            email: ""
                        },
                        cmsConfig: cmsConfig,
                        className: "mt-0"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BestsellerSliderBlock/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterBanner_NewsletterBanner, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var TravelPage_TravelPage = (TravelPage);

;// CONCATENATED MODULE: ./src/components/pages/TravelPage/index.tsx



/***/ }),

/***/ 30839:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingSidebar_root__Kk7FY","sidebarContent":"BookingSidebar_sidebarContent__N0BGN","mobileBar":"BookingSidebar_mobileBar__qxi3E","info":"BookingSidebar_info__ETHkQ","price":"BookingSidebar_price__zDVAs"};

/***/ }),

/***/ 58149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"SocialSharingModal_modal__81RoJ","close":"SocialSharingModal_close__hySil","body":"SocialSharingModal_body__Pb_Mn","heading":"SocialSharingModal_heading__tFenO","title":"SocialSharingModal_title__o6vPS","sharingLink":"SocialSharingModal_sharingLink__dpCYH","icon":"SocialSharingModal_icon__oZ1lB","iconWrap":"SocialSharingModal_iconWrap__XHLIi","label":"SocialSharingModal_label__E2AFz","footer":"SocialSharingModal_footer__KowGR","button":"SocialSharingModal_button__NT6tN"};

/***/ }),

/***/ 1701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"title":"TravelHighlightsList_title___5Z9U","list":"TravelHighlightsList_list__39ELU"};

/***/ }),

/***/ 46232:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"PageNavigation_root__RvxdU","navbar":"PageNavigation_navbar__4IWWP","nav":"PageNavigation_nav__Y3Egl","navLink":"PageNavigation_navLink__Pl_Tl","iconLinks":"PageNavigation_iconLinks__Xk5JI","iconLink":"PageNavigation_iconLink__nV6mb","iconLike":"PageNavigation_iconLike__vcVWk","icon":"PageNavigation_icon__xgYjj","label":"PageNavigation_label__peBjK","spinnerWrap":"PageNavigation_spinnerWrap__H2qBB","loadingSpinner":"PageNavigation_loadingSpinner__VMLZO","isLoading":"PageNavigation_isLoading__xK_Vo"};

/***/ }),

/***/ 86627:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"TravelPage_content__6cmtS"};

/***/ })

}]);